import {
  FETCH_START,
  FETCH_SUCCESS,
  FETCH_ERROR,
  SHOW_MESSAGE,
  GET_BLOGS,
} from '../../shared/constants/ActionTypes';
import jwtAxios from '@crema/services/auth/jwt-auth/jwt-api';

export const getBlogs = (limit = 10) => {
  return (dispatch, getState) => {
    const state = getState().exclusiveproperty;
    dispatch({type: FETCH_START});
    jwtAxios
      .get('/blog', {
        params: {
          pageNo: state.page,
          pageSize: limit,
          keyword: state.search,
        },
        // search: state.search,
        // page: state.page,
        // limit,
      })
      .then((data) => {
        if (data.status === 200) {
          dispatch({type: FETCH_SUCCESS});
          dispatch({
            type: GET_BLOGS,
            payload: data.data,
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: 'Something went wrong, Please try again!',
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error?.response?.data?.msg
            ? error?.response?.data?.msg
            : error?.message,
        });
      });
  };
};

export const addBlogs = (data) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    jwtAxios
      .post('/blog', data)
      .then((data) => {
        if (data.status === 200) {
          dispatch({type: FETCH_SUCCESS});
          dispatch({type: SHOW_MESSAGE, payload: data?.data?.message});
          dispatch(getBlogs());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: 'Something went wrong, Please try again!',
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error?.response?.data?.message ?? error?.message,
        });
      });
  };
};

export const updateBlog = (data) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    jwtAxios
      .put('/blog', data)
      .then((data) => {
        if (data.status === 200) {
          dispatch({type: FETCH_SUCCESS});
          dispatch({type: SHOW_MESSAGE, payload: data?.data?.message});
          dispatch(getBlogs());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: 'Something went wrong, Please try again!',
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error?.response?.data?.message ?? error?.message,
        });
      });
  };
};
// export const getBlogById = (id) => {
//   return (dispatch) => {
//     dispatch({type: FETCH_START});
//     jwtAxios
//       .get(`/blog/${id}`, {})
//       .then((data) => {
//         if (data.status === 200) {
//           dispatch({type: FETCH_SUCCESS});
//           dispatch({
//             type: GET_BLOG_BY_ID,
//             payload: data.data,
//           });
//         } else {
//           dispatch({
//             type: FETCH_ERROR,
//             payload: 'Something went wrong, Please try again!',
//           });
//         }
//       })
//       .catch((error) => {
//         dispatch({
//           type: FETCH_ERROR,
//           payload: error?.response?.data?.msg
//             ? error?.response?.data?.msg
//             : error?.message,
//         });
//       });
//   };
// };

export const deleteBlog = (id) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    jwtAxios
      .delete(`/blog?blogId=${id}`)
      .then((data) => {
        if (data.status === 200) {
          dispatch({type: FETCH_SUCCESS});
          dispatch({type: SHOW_MESSAGE, payload: data?.data?.message});
          dispatch(getBlogs());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: 'Something went wrong, Please try again!',
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error?.response?.data?.message ?? error?.message,
        });
      });
  };
};
